import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import ConsumerChannelsConfigHeaderLink from '../../components/ConsumerChannelsConfigHeaderLink/ConsumerChannelsConfigHeaderLink';
import { IConsumerChannelsLink } from '../../screens/ConsumerChannelsConfigScreen/types';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { SCREENS } from 'src/constants/screens';
import { appStore } from '~/mobx/appStore';

const ConsumerChannelsConfigHeaderLinks: FC = observer(() => {
  const linksArray = useMemo((): IConsumerChannelsLink[] => {
    const links: IConsumerChannelsLink[] = [];

    if (appStore.isAddonsAvailable.mobileApp) {
      links.push({ path: SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG_MOBILE(), title: 'Mobile_application', icon: Icons.ConsumerChannelMobile });
    }

    links.push({ path: SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG_WEB(), title: 'website', icon: Icons.ConsumerChannelWeb });

    if (appStore.isAddonsAvailable.kiosk) {
      links.push({ path: SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG_KIOSK(), title: 'kiosk', icon: Icons.ConsumerChannelKiosk });
    }

    links.push({ path: SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG_DOOK(), title: 'aggregator', icon: Icons.DookSecondary });

    return links;
  }, [appStore.isAddonsAvailable.mobileApp, appStore.isAddonsAvailable.kiosk]);

  return (
    <div className="d-flex flex-row gap-40">
      {linksArray.map((link) => (
        <ConsumerChannelsConfigHeaderLink key={link.title} link={link} />
      ))}
    </div>
  );
});

export default ConsumerChannelsConfigHeaderLinks;
